import * as z3 from 'zod/v3';
import * as z from 'zod/v4';

import { ArrayifyUnion } from '@watershed/shared-util/types/ArrayifyUnion';

import { CategoricalColumn, Columnar, PlainColumn } from './columnar';

export const filterValueNonNullSchemaZ3 = z3.union([
  z3.string(),
  z3.boolean(),
  z3.number(),
]);
export const filterValueNonNullSchema = z.union([
  z.string(),
  z.boolean(),
  z.number(),
]);

// NOTE: we use FilterValue in generated graphql types so don't rename it without also changing it in graphql.config.ts
// also be aware the changing this type (or the schema it comes from! filterValueNonNullSchema) will change both the input and output type of filters in generated graphql types
export type FilterValueZ3 = z3.infer<typeof filterValueNonNullSchemaZ3>;
export type FilterValue = z.infer<typeof filterValueNonNullSchema>;

export const biPrimitiveValueNonNullSchemaZ3 = filterValueNonNullSchemaZ3;
export const biPrimitiveValueNonNullSchema = filterValueNonNullSchema;

export type GQBiSingularPrimitiveNonNullValue = z.infer<
  typeof biPrimitiveValueNonNullSchema
>;

const biPrimitiveValueSchema = biPrimitiveValueNonNullSchema.nullable();
const biPrimitiveValueArraySchema: z.ZodType<GQBiRawArrayType> = z.union([
  z.array(z.string()),
  z.array(z.number()),
  z.array(z.boolean()),
]);
const biRawValueSchema = z.union([
  biPrimitiveValueSchema.optional(),
  biPrimitiveValueArraySchema,
]);
export const biDataRowSchema = z.record(z.string(), biRawValueSchema);

const plainBiColumnSchema: z.ZodType<PlainColumn<GQBiRawValueType>> = z.object({
  type: z.literal('plain'),
  data: z.array(biRawValueSchema),
});
const categoricalBiColumnSchema: z.ZodType<
  CategoricalColumn<GQBiRawValueType>
> = z.object({
  type: z.literal('categorical'),
  categories: z.array(biRawValueSchema),
  data: z.array(z.number()),
});
export const biDataResultSchema: z.ZodType<GQBiDataResult> = z.record(
  z.string(),
  z.union([plainBiColumnSchema, categoricalBiColumnSchema])
);

export type GQBiRawSingularType = z.infer<typeof biPrimitiveValueSchema>;

export type GQBiRawArrayType = ArrayifyUnion<GQBiSingularPrimitiveNonNullValue>;

export type GQBiRawValueType = z.infer<typeof biRawValueSchema>;

export type GQBiDataRow = z.infer<typeof biDataRowSchema>;
export type GQBiDataResult = Columnar<GQBiDataRow>;
